export const SMART_LINKS = Object.freeze({
  HOME: 'https://bokadirekt.smart.link/cl1p2rx9j',
  SERP: 'https://bokadirekt.smart.link/0tw64suoz',
  PLACE_TOP: 'https://bokadirekt.smart.link/au4ixz0bz',
  PLACE_FAVOURITES: 'https://bokadirekt.smart.link/ms9t9h2rz',
  CONFIRMED: 'https://bokadirekt.smart.link/lchf430kc',
  getPlaceFavouritesSmartLink: (placeUrl: string) => `${SMART_LINKS.PLACE_FAVOURITES}&deeplink=${placeUrl}`,
});
